import { useTranslation } from "react-i18next";
import Link from "../link/link";
import styles from "./shortcut-card.module.less";
import { TTarget } from "../../../types";

export type TShortcutCardProps = {
  linkUrl: string;
  eyebrow?: string;
  title?: string;
  subTitle?: string;
  target?: TTarget;
};

export const ShortcutCard = ({ linkUrl, eyebrow, title, subTitle, target }: TShortcutCardProps) => {
  const { t } = useTranslation();
  return (
    <Link
      ariaLabel={`${t("CLICK_TO_READ_MORE_ABOUT")} ${title}`}
      url={linkUrl}
      className={styles.wrapper}
      target={target}
    >
      <div className={styles.textWrapper}>
        {eyebrow && <p className={[styles.eyebrow, "eyebrow"].join(" ")}>{eyebrow}</p>}
        {title && <p className={[styles.title, "h5"].join(" ")}>{title}</p>}
        {subTitle && <p className={[styles.subTitle, "body-s"].join(" ")}>{subTitle}</p>}
      </div>
    </Link>
  );
};

export default ShortcutCard;
